import { FC } from "react";
import {
  SectionHeaderIcon,
  SectionHeaderWrapper,
  TextBold,
  TextWrapper,
} from "./Sections.styles";
import { Aligment, Button, Icon, Text, TextHeader } from "venice-ui";
import { dictionary } from "../../untils/dictionary";
import { t } from "../../helpers/userHelper";
import { Colors } from "../../untils/Theme";
import { useStoreState } from "../../store";

interface ISectionHeaderProps {
  title: string;
  actionLabel: string;
  sectionTitle: string;
  revision: number;
  activeTab: string;
  handleBack: () => void;
  handleClick: () => void;
  handleEditSection?: () => void;
  handleNewRevision?: () => void;
}
export const SectionHeader: FC<ISectionHeaderProps> = ({
  title,
  handleBack,
  handleClick,
  handleEditSection,
  handleNewRevision,
  actionLabel,
  sectionTitle,
  revision,
  activeTab,
}) => {
  const { orgRole } = useStoreState((state) => state.user.userDetails);
  const isReadOnly = orgRole === "readOnly";
  return (
    <SectionHeaderWrapper>
      <Aligment align="center" direction="row" width="100%;">
        <Aligment align="center" direction="row" width="auto">
          {handleBack && (
            <Icon name="back_arrow" onClick={() => handleBack()} left />
          )}
          <Aligment align="center" direction="row" width="auto" gap={32}>
            <TextWrapper>
              <TextHeader>{title}</TextHeader>
            </TextWrapper>
            <TextWrapper>
              <Text>{t(dictionary.section)}</Text>
              <TextBold>{sectionTitle}</TextBold>
              <SectionHeaderIcon>
                <Icon
                  name="edit"
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  size={14}
                  onClick={handleEditSection}
                  iconBgHoverColor="transparent"
                  tooltip={t(dictionary.editSection)}
                  isDisabled={isReadOnly}
                />
              </SectionHeaderIcon>
            </TextWrapper>
            <TextWrapper>
              <Text>{t(dictionary.revision)}</Text>
              <TextBold>{revision}</TextBold>
              {activeTab === "map" && (
                <SectionHeaderIcon>
                  <Icon
                    name="add"
                    iconColor={Colors.appBlue}
                    iconHoverColor={Colors.seaBlue}
                    size={14}
                    onClick={handleNewRevision}
                    iconBgHoverColor="transparent"
                    tooltip={t(dictionary.newRevision)}
                    isDisabled={isReadOnly}
                  />
                </SectionHeaderIcon>
              )}
            </TextWrapper>
          </Aligment>
        </Aligment>
        <Button
          mode="secondary"
          text={actionLabel}
          onClick={() => handleClick()}
        />
      </Aligment>
    </SectionHeaderWrapper>
  );
};
